import React, {useState} from 'react'
import { getFileName } from 'helpers/FileCaching';
import { Tabs, Tab } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import globalJSON from '../../../data/global.json'
import classes from './InDepth.module.scss';

function trackingSeriesOneTab(key){
	window.gtag('event', "series one tabs clicked", {
		'event_category': globalJSON.tracking.ga_category,
		'event_label': "series one tabs clicked",
		'value':10
	});
}

function trackingSeriesTwoTab(key){
	window.gtag('event', "series two tabs clicked", {
		'event_category': globalJSON.tracking.ga_category,
		'event_label': "series two tabs clicked",
		'value':10
	});
}

function trackingEpisodeClicked(event){
	window.gtag('event', "in-Dept episode clicked", {
		'event_category': globalJSON.tracking.ga_category,
		'event_label': "in-Dept episode clicked "+ event.url,
		'value':10
	});
	
}


const seriesVideoThumbnails = require.context('../../../images/components/InDepth', true, /.*\.(gif|png|jpe?g|svg)$/i);

function InDepth({content, windowSize}) {
    const [key, setKey] = useState('series_Two');
   
    let seriesOne = content.series_one.map((item, index) => 
        <div key={index} className={`${classes['InDepth__article']}`}>
            <a onClick={() => trackingEpisodeClicked(item, index)} href={item.url} target={"_blank"}>
                <div className={`remove-img-color smooth ${classes.InDepth__article_hover}`}>
                    <div className={`${classes['InDepth__article_wrapper']}`} >    
                        <img className={`remove-img-element ${classes.InDepth__article_image}`} alt={item.imageTitle} src={getFileName(seriesVideoThumbnails, item.image)}></img>
                    </div>
                    <h3 className={classes.InDepth__article_title}>{item.title}</h3>
                    <div className={'divider_grey_article'}></div>
                </div>
            </a>
        </div>
    )

    let seriesTwo = content.series_two.map((item, index) => 
        <div key={index} className={` ${classes['InDepth__article']}`}>
            <a onClick={() => trackingEpisodeClicked(item, index)} href={item.url} target={"_blank"}>
                <div className={`remove-img-color smooth ${classes.InDepth__article_hover}`}>
                    <div className={`remove-img-element ${classes['InDepth__article_wrapper']}`} >
                        <img className={classes.InDepth__article_image} alt={item.title} src={getFileName(seriesVideoThumbnails, item.image)}></img>
                    </div>
                    <h3 className={classes.InDepth__article_title}>{item.title}</h3>
                    <div className={`divider_grey_article ${classes.InDepth__article_divider}`}></div>
                </div>
             
            </a>
        </div>
    );

    function handleSelect(key) {
        if (key === "series_One")
            trackingSeriesOneTab();    
        else if(key === "series_Two")
            trackingSeriesTwoTab(); 
    }
    

    return (
        <div className={classes.InDepth}>
            {/* <SectionHero content={jsonHub.InDepth} windowSize={windowSize}/> */}
            <div className='container-fluid' style={{padding:'0'}}>
                <div className={`row`}  style={{margin: 0}}>
                    <div className={`col-md-12 col-lg-10`} style={{margin: '0 auto'}}>
                        <Tabs
                            id="in-depth-tabs"
                            activeKey={key}
                            onSelect={(k) => {setKey(k); handleSelect(k)}}
                        >
                        {/* disabled */}
                            <Tab eventKey="series_Two" title="Series Two" className={classes.InDepth__tab}>
                                <div className={`${classes['InDepth__container']}`}>
                                    <div className={`${classes['InDepth__article_container']}`}>
                                        {seriesTwo}
                                    </div>
                                </div>
                            </Tab>
                            <Tab eventKey="series_One" title="Series One">
                                <div className={`${classes['InDepth__container']}`}>
                                    <div className={`${classes['InDepth__article_container']}`}>
                                        {seriesOne}
                                    </div>
                                </div>
                            </Tab>
                        </Tabs>
      
                    </div>
                </div>
            </div>
        </div>
	)

}

export default InDepth;